// frontend/src/api/user.ts
import axios from 'axios';
import { User } from '@/interfaces/user';

const API_URL = import.meta.env.VITE_API_URL;

export const getUsers = async (): Promise<User[]> => {
  try {
    const { data } = await axios.get<User[]>(
      `${API_URL}/api/v1/admin/users`, // <-- Fix endpoint to include /v1
      {
        headers: {
          'Authorization': `Bearer ${localStorage.getItem('token')}`
        }
      }
    );
    return data;
  } catch (error) {
    console.error('Get users error:', error);
    throw error;
  }
};

export const updateUserStatus = async (email: string, isActive: boolean): Promise<{ message: string }> => {
  try {
    const { data } = await axios.put(
      `${API_URL}/api/v1/admin/users/${encodeURIComponent(email)}?is_active=${isActive}`,
      null, // No request body is needed
      {
        headers: {
          'Authorization': `Bearer ${localStorage.getItem('token')}`,
        },
      }
    );
    return data; // Return the response message
  } catch (error) {
    console.error('Update user status error:', error);
    throw error;
  }
};

export const createUser = async (user: { DisplayName: string; Email: string; Role: string }): Promise<any> => {
  try {
    const { data } = await axios.post(
      `${API_URL}/api/v1/admin/users/`, // Ensure the trailing slash is included
      user,
      {
        headers: {
          'Authorization': `Bearer ${localStorage.getItem('token')}`,
          'Content-Type': 'application/json', // Ensure Content-Type is set
        },
      }
    );
    return data; // Return the full response data
  } catch (error) {
    console.error('Create user error:', error);
    throw error;
  }
};

// Add axios interceptor for handling 401 responses
axios.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      // Clear token and redirect to login
      localStorage.removeItem('token');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);